import { queryClient } from "../queryClient";

/**
 * Ends the admin's session in this browser.
 *
 * Used on sign out, whenever the API answers 401, and before a new sign-in
 * writes its token. It removes everything the app stored for the signed-in
 * admin (token, user, the bell's seen count, ...) but keeps the choices that
 * belong to the browser: the light / dark theme and the pinned sidebar.
 * localStorage.clear() used to wipe those too, on every expired session (the
 * project rule; the seller app's utils/session.js does the same).
 *
 * It also empties the data cache. The React Query cache lives for as long as
 * the tab and its keys are not per account, so the next admin to sign in on
 * the same tab saw the previous one's sellers and orders until each refetch
 * landed (pipeline audit P1-01, P2-03).
 */
const KEEP = ["app-theme", "sidebar-pinned"];

export function clearSession() {
  try {
    const keys = [];
    for (let i = 0; i < localStorage.length; i += 1) keys.push(localStorage.key(i));
    keys.filter((k) => k && !KEEP.includes(k)).forEach((k) => localStorage.removeItem(k));
  } catch {
    // Storage blocked (private mode, disabled site data): nothing to clear.
  }
  queryClient.clear();
}
